import { render, staticRenderFns } from "./ActivityRule.vue?vue&type=template&id=6b5d1c72&scoped=true&"
import script from "./ActivityRule.vue?vue&type=script&lang=ts&"
export * from "./ActivityRule.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityRule.vue?vue&type=style&index=0&id=6b5d1c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d1c72",
  null
  
)

export default component.exports